// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1foFa","buttons":"RemoveExpirationActionButtons_buttons__1MLXF"};